// extracted by mini-css-extract-plugin
export default {"editBody":"ProfileEdit_editBody__H7Oi4","field":"ProfileEdit_field__OfFQ-","title":"ProfileEdit_title__q4+QE"};